import React, { useState, useRef, useEffect } from "react";
import LuckyDrawSelectComponent from "./luckyDrawSelect.component";
import LuckyDrawSelectPanelComponent from "./luckyDrawSelectPanel.component";
import { selectLoading } from "modules/notification";
import { useDispatch, useSelector } from "react-redux";
import { getAvailableLuckyDrawDropdown } from "modules/lucky-draw/redux";
import { unwrapResult } from "@reduxjs/toolkit";

function LuckyDrawSelectContainer({
  placeholder,
  handleChange,
  value,
  disabled,
  styles,
  searchPlaceholder,
  searchable,
  textStyles,
}) {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.constant.languages);
  const isFetching = useSelector((state) =>
    selectLoading(state, getAvailableLuckyDrawDropdown.typePrefix)
  );
  const productId = useSelector((state) => state.productPage.productId);
  const components = useSelector((state) => state.productPage.components);

  const [open, setOpen] = useState(false);
  const [isOpenList] = useState(false);
  const anchorRef = useRef(null);
  const prevOpen = useRef(open);
  const prevOpenList = useRef(isOpenList);

  const [list, setList] = useState([]);
  const [totalFiltered, setTotalFiltered] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(true);
  const [isError, setIsError] = useState(false);

  const [filter, setFilter] = useState({
    page: 0,
    rowsPerPage: 30,
    search: "",
  });

  const [ldList, setLdList] = useState([]);

  useEffect(() => {
    let temp = [...list];
    let ldComp = Object.keys(components).filter((c) =>
      c.startsWith("lucky draw")
    );
    if (ldComp) {
      let usedId = [];
      ldComp.forEach((key) => {
        let comp = components[key];
        if (comp?.content?.id && comp.content.id !== value) {
          usedId.push(comp.content.id);
        }
      });
      temp = temp.filter((t) => !usedId.includes(t.uuid));
    }

    setLdList(temp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list, components]);

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  useEffect(() => {
    if (prevOpenList.current === true && isOpenList === false) {
      anchorRef.current.focus();
    }

    prevOpenList.current = isOpenList;
  }, [isOpenList]);

  useEffect(() => {
    // filtered should be a reset, has next page validation not needed
    // if (hasNextPage && !isFetching) {
    if (!isFetching) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, dispatch]);

  const getData = () => {
    if (isError) setIsError(false);
    let param = {
      length: filter.rowsPerPage,
      start: filter.rowsPerPage * filter.page,
      search: filter.search,
      product_uuid: productId,
    };

    dispatch(getAvailableLuckyDrawDropdown(param))
      .then(unwrapResult)
      .then((res) => {
        let temp = [...list, ...res.data];
        setList(temp);
        setTotalFiltered(res.records_filtered);
        setHasNextPage(temp.length < res.records_filtered);
      })
      .catch(() => {
        setIsError(true);
      });
  };

  const handleSearch = (search) => {
    setList([]);
    setFilter({
      ...filter,
      page: 0,
      search: search,
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = () => {
    setOpen(true);
  };

  const handleFetchMoreItems = () => {
    if (hasNextPage) {
      const newFilter = { ...filter, page: filter.page + 1 };
      setFilter(newFilter);
    }
  };

  const handleReload = () => {
    setList([]);
    setFilter({
      ...filter,
      page: 0,
      search: "",
    });
  };

  const handleSelectLuckyDraw = (ld) => {
    handleChange(ld);
    handleClose();
  };

  return (
    <>
      <LuckyDrawSelectComponent
        anchorRef={anchorRef}
        handleClick={handleClick}
        value={value}
        styles={styles}
        placeholder={placeholder}
        disabled={disabled}
        textStyles={textStyles}
        lang={lang}
        luckyDraws={ldList}
      />
      <LuckyDrawSelectPanelComponent
        value={value}
        anchorRef={anchorRef}
        open={open}
        handleClose={handleClose}
        isFetching={isFetching}
        luckyDraws={ldList}
        handleSelectLuckyDraw={handleSelectLuckyDraw}
        searchable={searchable}
        placeholder={searchPlaceholder}
        handleSearch={handleSearch}
        lang={lang}
        totalFiltered={totalFiltered}
        handleFetchMoreItems={handleFetchMoreItems}
        hasNextPage={hasNextPage}
        isError={isError}
        handleReload={handleReload}
        currentTotal={ldList.length}
      />
    </>
  );
}

export default LuckyDrawSelectContainer;
